import React, { useContext } from "react";
import { Table } from "antd";
import {
  expertServiceTypes,
  getReadableValue,
  maskedStatus,
  paginationConfig
} from "../../../../../../../helpers";
import { Format, ServiceCost, StatusTag } from "../../../../../../shared";
import {
  PaginationContext
} from "../../../../../../../contexts/shared";

export function AssignationsTable({
  loading = false,
  items: assignations = [],
  currentPage,
  onChangePage,
  totalRecordsCount,
  paginationRefetchName,
  openModal
}) {
  const { onPaginationChange } = useContext(PaginationContext);

  const handlePaginationChange = (page, pageSize) => {
    onChangePage(page, pageSize);
    onPaginationChange(paginationRefetchName)(page, pageSize);
  };

  const handleOnRowClick = assignedExpertService => ({
    onClick: () =>  openModal({ assignedExpertService }),
    className: "clickable"
  });

  return (
    <Table
      loading={loading}
      scroll={{ x: true }}
      style={{ width: "100%" }}
      dataSource={assignations || []}
      rowKey={(row, index) => row?.id || index}
      onRow={handleOnRowClick}
      pagination={{
        ...paginationConfig,
        current: currentPage,
        defaultPageSize: 12,
        onChange: (page, pageSize) => handlePaginationChange(page, pageSize),
        total: totalRecordsCount
      }}>
      <Table.Column
        title="Compañía"
        render={({ ode, expertServiceData }) =>
          expertServiceData.type === "WORKSHOP" ? null : ode?.name
        } />
      <Table.Column
        title="Programa"
        render={({ batch }) => batch?.program?.name} />
      <Table.Column
        title="Batch"
        render={({ batch }) => batch?.name} />
      <Table.Column
        title="Producto"
        render={({ expertServiceData }) => expertServiceData?.name} />
      <Table.Column
        title="Experto"
        render={assignedExpertService =>
          assignedExpertService?.expertServiceData?.expert?.fullName} />
      <Table.Column
        title="Tipo de producto"
        render={({ expertServiceData }) =>
          getReadableValue(expertServiceTypes, expertServiceData?.type) } />
      <Table.Column
        align="center"
        title="Costo total"
        render={({ assignedUnits, ...assignedExpertService }) =>
          <ServiceCost
            duration={assignedUnits}
            assignedExpertService={assignedExpertService} />} />
      <Table.Column
        align="center"
        title="Fecha de asignación"
        render={({ assignmentDate }) =>
          <Format type="date">{assignmentDate}</Format>
        } />
      <Table.Column
        align="center"
        title="Fecha límite de consumo"
        render={({ limitDate }) =>
          <span className="bold">
            <Format type="date">{limitDate}</Format>
          </span>
        } />
      <Table.Column
        align="center"
        title="Estado"
        render={({ status, limitDate, availableUnits, assignedUnits }) => {
          const newStatus = maskedStatus({
            status,
            limitDate,
            availableUnits,
            assignedUnits
          });
          return (<StatusTag status={newStatus} />);
        }} />
    </Table>
  );
}
